import { BikeSpec } from './types';

/** GASGAS EC 250 (2T, 2024). GASGAS spec sheet: 249 cc 2T fuel injected, 6 speed, 106.2 kg without fuel. */
export const GASGASEC250: BikeSpec = {
  id: 'gasgasec250', brand: 'GASGAS', name: 'EC 250', year: 2024, kind: 'enduro', stroke: '2T', displacement: 249,
  dryMass: 106.2, peakPower: 36, peakPowerRpm: 8500, peakTorque: 38, peakTorqueRpm: 7700, limiterRpm: 9500, idleRpm: 1500,
  torqueCurve: [[1500, 0.4], [3500, 0.6], [6000, 0.9], [7700, 1], [8500, 0.95], [9500, 0.78]],
  primary: 72 / 26, gearbox: [32 / 14, 28 / 16, 29 / 20, 26 / 21, 25 / 23, 23 / 25], finalDrive: 50 / 13,
  travelFront: 300, travelRear: 310, seatHeight: 950, wheelbase: 1487,
  level: 'advanced', discipline: 'enduro', livery: 'gasgas',
  model: { file: 'fleet/gasgasec250.glb', base: 'generic 2-stroke dirt bike in GASGAS colours', approximate: true },
  schoolMap: 0.75,
  audio: { set: '2t', pitch: 0.92 },
  estimated: ['peakPower', 'peakTorque', 'limiterRpm', 'torqueCurve', 'gearbox'],
};
